import '@mdi/font/css/materialdesignicons.css';
import Progress from 'easy-circular-progress';
import { Inject } from 'vue-di-container';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import LoaderService from '../../Services/LoaderService';
import { Toaster } from '../../Services/toast';
import ValidationService from '../../Services/ValidationService';
import { SenderType } from '../../shared/Enums/SenderType';
import ProviderStatusService from '../../shared/ProviderStatusService/ProviderStatusService';
import UserModel from '../../shared/userService/Model/UserModel';
import UserRoleService from '../../shared/userService/UserRoleService';
import UserService from '../../shared/userService/UserService';
import { RejectionReasonModel } from '../RejectionReason/RejectionReasonModel';
import { DropdownModel, ReportModel } from '../Report/ReportModel';
import ReportService from '../Report/ReportService';
import WithRender from './Dashboard.html';
import { DashboardBoxesModel } from './DashboardBoxesModel';
import DashboardService from './DashboardService';
import { FilterModel } from './FilterModel';
import { ReportOptionsModel } from './ReportOptionsModel';
import { RequestsOptionsModel } from './RequestsOptionsModel ';
import { SenderRequestModel } from './SenderRequestModel';


@WithRender
@Component({
    components: {
        Progress,
    },
    diProvide: [
        DashboardService,
        UserService,
        ReportService,
        UserRoleService,
        ProviderStatusService
    ],
    computed: {
        favoriteIconColor(): string {
            const theme = process.env.VUE_APP_TITLE || 'Default';
            console.log('theme in Dashboard:', theme);
            switch (theme) {
                case 'Mobily':
                    return '#5EC1D9';
                case 'Zain':
                    return '#76C57E';
                default:
                    return '#D09BE6';
            }
        },
    }
})
export default class Dashboard extends Vue {

    @Inject(UserService) public userService!: UserService;
    @Inject(DashboardService) public dashboardService!: DashboardService;
    @Inject(LoaderService) public loaderService!: LoaderService;
    @Inject(ValidationService) public validationService!: ValidationService;
    @Inject(ReportService) public reportService!: ReportService;
    @Inject(UserRoleService) public userRoleService!: UserRoleService;
    @Inject(ProviderStatusService) public providerStatusService!: ProviderStatusService;


    public providerLocked: boolean = true;
    public providerDissconected: boolean = true;
    public providerExpired: boolean = true;
    public layoutSup: boolean | any;
    public requestStatus: number[] = [];
    requestStatusBox: string[] = [];
    public crNumber: string = '';
    public enterpriseUnifiedNumber: string = '';
    public customerType: number = 0;
    public senderStatus: string = '';
    public Deactivateids: string[] = [];
    public deactivateDialog: boolean = false;
    /** True when opened from the header bulk button; false when opened from a row Actions menu. */
    public deactivateIsBulkAction: boolean = false;
    public senderStatusModel: any = {
        senderName: '',
        clientName: '',
        crNumber: '',
        enterpriseUnifiedNumber: '',
        customerType: '',
        senderType: '',
        senderStatus: '',
        hrsdLicense: '',
        isAlreadyExist: '',
    };
    public requestsDateExpiryOptions: any =
        [
            { "id": 1, "name": "90 Days" },
            { "id": 2, "name": "30 Days" },
            { "id": 3, "name": "7 Days" },
        ];
    public Deleteids: string[] = [];
    public deleteDialog: boolean = false;
    public isExportExcelForProviderEnabled: boolean = false;
    public approveids: string[] = [];
    public approveDialog: boolean = false;
    public finalApproveDialog: boolean = false;
    public resendids: string[] = [];
    public resendDialog: boolean = false;
    public favoriteDialog: boolean = false;
    public unfavoriteDialog: boolean = false;
    public resendComment: string = '';
    public approveComment: string = '';
    public deleteComment: string = '';
    public checkSenderDialog: boolean = false;
    public checkAvailabilityDialog: boolean = false;
    public checkAvailabilitySenderName: string = '';
    public notFounDialog: boolean = false;
    public requestsFilterExpiryOption: number = 0;
    public createdDateToMenu: boolean = false;
    public createdDateFromMenu: boolean = false;
    public isLoading: boolean = true;

    public filterModel: FilterModel = {
        senderName: '',
        clientName: '',
        createdDate: '',
        providerName: '',
        requestId: '',
        displayId: '',
        status: [],
        createdDateFrom: '',
        createdDateTo: ''
    };
    public reportModel: ReportModel = {
        requestId: '',
        displayId: '',
        tenantName: '',
        senderName: '',
        approveDateFrom: '',
        approveDateTo: '',
        createdDateFrom: '',
        createdDateTo: '',
        customerType: 0,
        senderType: 0,
        providerId: '',
        clientName: '',
        comment: '',
        representativeName: '',
        representativeMobile: '',
        requestStatus: [],
        senderStatus: 0,
        numberOfActions: 0,
        paymentDate: '',
        expiryDate: '',
        filterContractOption: 0,
        filterExpiryOption: 0,
        requestsFilterExpiryOption: 0,
        representativeEmail: '',
        pageIndex: '0',
        pageSize: '10',
    };
    public statusOptions: any[] = [
        {
            id: '1',
            name: this.$t('dashboardPage.pendingFor').toString()
                + ' ' + this.$t('dashboardPage.approval').toString(),
        },
        {
            id: '2',
            name: this.$t('dashboardPage.pendingFor').toString()
                + ' ' + this.$t('dashboardPage.payment').toString(),
        },
        {
            id: '3',
            name: this.$t('dashboardPage.rejected').toString()
                + ' ' + this.$t('dashboardPage.requests').toString(),
        },
        {
            id: '4',
            name: this.$t('dashboardPage.inactive').toString()
                + ' ' + this.$t('dashboardPage.requests').toString(),
        },
        {
            id: '5',
            name: this.$t('dashboardPage.active').toString()
                + ' ' + this.$t('dashboardPage.requests').toString(),
        },
        {
            id: '7',
            name: this.$t('dashboardPage.partially').toString()
                + ' ' + this.$t('dashboardPage.activated').toString(),
        },
        {
            id: '8',
            name: this.$t('dashboardPage.pendingFor').toString()
                + ' ' + this.$t('dashboardPage.verify').toString(),
        },
    ];

    public user: UserModel = {
        userId: '',
        username: '',
        details: {
            Email: '',
            MobilePhone: '',
            Operator: '',
            Provider: '',
            OperatorId: '',
            ProviderId: '',
            TenantId: '',
            Role: '',
            ChangePasswordRequired: '',
        },
    };
    public senderName: string = '';
    public autoInterval: any;
    public userRole: number = 0;
    public scrollDiv: any;
    public nextPage: string = '';
    public scrollTop: number = 0;
    public selected: SenderRequestModel[] = [];
    public selectedIds: string[] = [];
    public selectedSenderIds: string[] = [];
    public ids: string[] = [];
    public senders: SenderRequestModel[] = [];
    public sendersCount: number = 0;
    public dashboardBoxes: DashboardBoxesModel = {} as DashboardBoxesModel;
    public requestsOptions: RequestsOptionsModel = {} as RequestsOptionsModel;
    public reportOptionsModel: ReportOptionsModel = {} as ReportOptionsModel;
    public User: any;
    public isSorted: boolean = false;
    public rejectResone: string = '';
    public selectedRejectReason: RejectionReasonModel = {} as RejectionReasonModel;
    public rejectdialog: boolean = false;
    public anySelected: boolean = false;
    public pagination: any = {
        page: 1,
        rowsPerPage: 10,
        sortBy: "createdDate",
        sortDirection: true
    };
    public tenantId: string = '';
    public senderType: number[] = [];
    public isFromFilterBox: boolean = false;

    public senderTypeList: DropdownModel[] = [
        {
            id: SenderType.Advertisement,
            name: this.$t('shared.advertisement').toString(),
        },
        {
            id: SenderType.Service,
            name: this.$t('shared.service').toString(),
        },
        {
            id: SenderType.Awareness,
            name: this.$t('shared.awareness').toString(),
        },
        {
            id: SenderType.Warning,
            name: this.$t('shared.warning').toString(),
        },
    ];
    public headers: any = [
        { text: this.$t('dashboardPage.displayId'), sortable: true, value: 'displayId', align: 'center' },
        { text: this.$t('dashboardPage.senderName'), sortable: true, value: 'senderName', align: 'center' },
        { text: this.$t('dashboardPage.clientName'), sortable: true, value: 'clientName', align: 'center' },
        {
            text: this.$t('dashboardPage.requestDate'), sortable: true,
            value: 'createdDate', align: 'center',
        },
        {
            text: this.$t('shared.expiryDate'), sortable: true,
            value: 'expiryDate', align: 'center',
        },
        {
            text: this.$t('dashboardPage.status'), sortable: false, value: 'requestStatus',
            align: 'center', width: '190',
        },
        { text: this.$t('shared.actions'), sortable: false, align: 'center', width: '145' },
    ];


    public popUpRejectionReasons: RejectionReasonModel[] = [];
    public isItOtherReasonPorp: boolean = false;
    public changeSort(column: any) {
        if (this.pagination.sortBy === column) {
            this.pagination.descending = !this.pagination.descending;
        } else {
            this.pagination.sortBy = column;
            this.pagination.descending = false;
        }
        this.isSorted = true;
        this.updatePaginate(this.pagination);
    }
    public async renewRegisterSender() {
        this.$router.push({
            name: 'RenewRegisterSender',
            query: { renewalSource: 'senderDashboard' },
        });
    }
    public checkColor(typeStatus: string) {
        typeStatus = typeStatus.toString();
        switch (typeStatus) {
            case '1': {
                return '#c427ba';
                break;
            }
            case '2': {
                return '#5aaa0b';
                break;
            }
            case '3': {
                return '#C42727';
                break;
            }
            case '4': {
                return '#aaa7a7';
                break;
            }
            case '5': {
                return '#014bb1';
                break;
            }
            case '7': {
                return '#5c9bf2';
                break;
            }
            case '8': {
                return '#80EF80';
                break;
            }
            case '10': {
                return '#9b2a5a';
                break;
            }
            case '11': {
                return '#421984';
                break;
            }
            default: {
                return '#F78500';
                break;
            }
        }
    }

    public getSenderType() {
        this.senderType = [];
        const senderBinary = this.senderStatusModel.senderType;
        if ((senderBinary & 1) === 1) {
            this.senderType.push(1);
        }
        if ((senderBinary & 2) === 2) {
            this.senderType.push(2);
        }
        if ((senderBinary & 4) === 4) {
            this.senderType.push(4);
        }
        if ((senderBinary & 8) === 8) {
            this.senderType.push(8);
        }
    }

    public getSenderTypeText(typeId: number) {
        switch (typeId) {
            case SenderType.Advertisement:
                return this.$t('shared.advertisement').toString();
            case SenderType.Service:
                return this.$t('shared.service').toString();
            case SenderType.Awareness:
                return this.$t('shared.awareness').toString();
            case SenderType.Warning:
                return this.$t('shared.warning').toString();
            default:
                return '-';
        }
    }


    public async checkSenderStatus() {
        var response = await this.dashboardService.getSenderStatus(this.senderName);
        if (response.isSuccess) {
            this.senderStatusModel = response.result;
            this.getSenderType();
            this.senderStatusModel.senderStatus = this.getSenderStatusById(this.senderStatusModel.senderStatus);
            this.checkSenderDialog = true;
        } else {
            Toaster.error(this.$t('dashboardPage.senderNotFound').toString());
        }
    }

    public hideCheckSenderdialog() {
        this.checkSenderDialog = false;
    }

    public openCheckAvailabilityDialog() {
        this.checkAvailabilitySenderName = '';
        this.checkAvailabilityDialog = true;
    }

    public hideCheckAvailabilityDialog() {
        this.checkAvailabilityDialog = false;
    }

    public async submitCheckAvailability() {
        this.checkAvailabilityDialog = false;
        this.senderName = this.checkAvailabilitySenderName;
        var response = await this.dashboardService.getSenderStatus(this.senderName);
        if (response.isSuccess) {
            this.senderStatusModel = response.result;
            this.getSenderType();
            this.senderStatusModel.senderStatus = this.getSenderStatusById(this.senderStatusModel.senderStatus);
            this.checkSenderDialog = true;
        } else {
            Toaster.error(this.$t('dashboardPage.senderNotFound').toString());
        }
    }


    public getSenderStatusById(typeStatus: number) {
        switch (typeStatus) {
            case 2: {
                return this.$t('shared.approved').toString();
                break;
            }
            case 4: {
                return this.$t('shared.deactivated').toString();
                break;
            }
            case 5: {
                return this.$t('shared.expired').toString();
                break;
            }
            case 7: {
                return this.$t('shared.paid').toString();
                break;
            }
            case 10: {
                return this.$t('shared.pendingForReview').toString();
                break;
            }
        }
    }

    public GetSenderStatus(typeStatus: string) {
        typeStatus = typeStatus.toString();
        switch (typeStatus) {
            case '1': {
                return 'Pending Approval';
                break;
            }
            case '2': {
                return 'Approved';
                break;
            }
            case '3': {
                return 'Rejected';
                break;
            }
            case '4': {
                return 'Paid';
                break;
            }
            case '5': {
                return 'Expired';
                break;
            }
            case '6': {
                return 'Deleted';
                break;
            }
            case '7': {
                return 'Partially Activated';
                break;
            }
            case '9': {
                return 'Pending For Verify';
                break;
            }
            case '10': {
                return 'Pending For Review';
                break;
            }
            case '11': {
                return 'Deactivated';
                break;
            }
            default: {
                return 'Deactivated';
                break;
            }
        }
    }


    public async mounted() {
        this.$emit('childinit', this.layoutSup);
        this.User = await this.userService.getUser();
        this.userRole = this.userRoleService.GetUserRole(this.User);
        if (this.userRole === 2 || this.userRole === 5) {
            this.isProviderLocked();
            this.isProviderExpired();
            this.isProviderDissconected();
        }
        this.getRequestsOptions();
        this.getReportOptions();
        this.dashboardBoxes = await this.dashboardService.GetDashboardBoxes();
        this.tenantId = this.User.details.TenantId;
        this.getRejectionReasons();
        if (this.userRole != 2 && this.userRole != 5) {
            this.getHeaders();
        }
        this.search();
    }
    public async getRequestsOptions() {
        const response = await this.dashboardService.getRequestsOptions();
        this.requestsOptions.isChangeSenderTypeEnabled = response.result.isChangeSenderTypeEnabled;
        this.requestsOptions.isNewRequestEnabled = response.result.isNewRequestEnabled;
        this.requestsOptions.isUpdateRequstDataEnabled = response.result.isUpdateRequstDataEnabled;
        this.requestsOptions.isRenewRequstEnabled = response.result.isRenewRequstEnabled;
    }
    public async getReportOptions() {
        const response = await this.dashboardService.getReportOptions();
        this.isExportExcelForProviderEnabled = response.result.isExportExcelForProviderEnabled;
    }
    public isWithinTwoHours(date: string | Date): boolean {

        if (!date)
            return false;

        const created = new Date(date);
        const now = new Date();

        return (now.getTime() - created.getTime()) <= 2 * 60 * 60 * 1000;
    }

    public async getHeaders() {
        const providerColumn = {
            text: this.$t('dashboardPage.providerName'), sortable: true,
            value: 'providerName', align: 'center',
        };
        this.headers.splice(3, 0, providerColumn);
    }
    public async isProviderLocked() {
        const response = await this.dashboardService.isProviderLocked();
        this.providerLocked = response.result;
    }
    public async isProviderDissconected() {
        const response = await this.providerStatusService.isProviderDissconected();
        this.providerDissconected = response.result;
    }
    public async isProviderExpired() {
        const response = await this.dashboardService.isProviderExpired();
        this.providerExpired = response.result;
    }

    public async reset() {
        localStorage.removeItem('storSettings');
        this.filterModel = {
            senderName: '',
            requestId: '',
            displayId: '',
            clientName: '',
            providerName: '',
            createdDate: '',
            createdDateFrom: '',
            createdDateTo: '',
            status: [],
        };
        this.requestStatus = [];
        this.senderStatus = '';
        this.requestsFilterExpiryOption = 0,
            this.pagination = {
                page: 1,
                rowsPerPage: 10,
                sortBy: '',
                descending: false,
            };
        if (!this.isFromFilterBox && (this.requestStatusBox.length > 0 || !this.requestStatusBox.includes('0'))) {
            this.requestStatusBox = ['0'];
        }
        if (this.searchTimeout) clearTimeout(this.searchTimeout);
        await this.search();
    }

    public async search() {
        let model;
        if (localStorage.storSettings) {
            const storSettings = JSON.parse(localStorage.storSettings);
            this.pagination = storSettings.pagination;

            this.filterModel.senderName = storSettings.filter.senderName;
            this.filterModel.requestId = storSettings.filter.requestId;
            this.filterModel.displayId = storSettings.filter.displayId;
            this.filterModel.clientName = storSettings.filter.clientName;
            this.filterModel.providerName = storSettings.filter.providerName;
            this.filterModel.createdDate = storSettings.filter.createdDate;
            this.filterModel.createdDateFrom = storSettings.filter.createdDateFrom;
            this.filterModel.createdDateTo = storSettings.filter.createdDateTo;
            this.filterModel.status = storSettings.filter.requestStatuses || [];
            this.requestStatusBox = this.filterModel.status.map(s => s.toString());
            this.requestsFilterExpiryOption = storSettings.filter.requestsFilterExpiryOption || 0;
            this.senderStatus = (storSettings.filter.senderStatus != null) ? storSettings.filter.senderStatus.toString() : '';
            model = {
                senderName: this.filterModel.senderName,
                requestId: this.filterModel.requestId,
                displayId: this.filterModel.displayId,
                clientName: this.filterModel.clientName,
                providerName: this.filterModel.providerName,
                createdDate: this.filterModel.createdDate,
                createdDateFrom: this.filterModel.createdDateFrom,
                createdDateTo: this.filterModel.createdDateTo,
                requestStatuses: this.filterModel.status,
                senderStatus: this.senderStatus !== '' ? parseInt(this.senderStatus, 10) : 0,
                requestsFilterExpiryOption: this.requestsFilterExpiryOption,
                sortDirection: false,
                sortBy: '',
                pageIndex: '0',
                pagesize: this.pagination.rowsPerPage,
            };
        } else {
            model = {
                senderName: this.filterModel.senderName,
                requestId: this.filterModel.requestId,
                displayId: this.filterModel.displayId,
                clientName: this.filterModel.clientName,
                providerName: this.filterModel.providerName,
                createdDate: this.filterModel.createdDate,
                createdDateFrom: this.filterModel.createdDateFrom,
                createdDateTo: this.filterModel.createdDateTo,
                requestStatuses: this.filterModel.status,
                senderStatus: this.senderStatus !== '' ? parseInt(this.senderStatus, 10) : 0,
                requestsFilterExpiryOption: this.requestsFilterExpiryOption,
                sortDirection: false,
                sortBy: '',
                pageIndex: '0',
                pagesize: this.pagination.rowsPerPage,
            };
        }
        localStorage.removeItem('storSettings');
        const response = await this.dashboardService.Get(model);
        if (response !== false) {
            if (!response.isSuccess) {
                Toaster.error(response.errorMessage);
            }
        }
        this.senders = response.result;
        this.sendersCount = response.totalCount;
        this.dashboardBoxes = await this.dashboardService.GetDashboardBoxes();
    }

    public isEqual(value1: string | null, value2: string) {
        return (value1 === '' || value1 === null || value2.includes(value1));
    }

    public async filter(requestStatus: string, senderStatus: string) {
        this.senderStatus = '';

        // requestStatusBox toggle
        if (requestStatus === '0') {
            //"All" selected, reset everything else
            this.requestStatusBox = ['0'];
        } else {
            // Remove "All" if already selected
            this.requestStatusBox = this.requestStatusBox.filter(s => s !== '0');

            const index = this.requestStatusBox.indexOf(requestStatus);
            if (index === -1) {
                this.requestStatusBox.push(requestStatus);
            } else {
                this.requestStatusBox.splice(index, 1);
            }

            //  no selections , back to "All"
            if (this.requestStatusBox.length === 0) {
                this.requestStatusBox = ['0'];
            }
        }

        if (this.requestStatusBox.includes('0')) {
            this.filterModel.status = [];
        } else {
            this.isFromFilterBox = true;
            this.filterModel.status = this.requestStatusBox.map(s => parseInt(s, 10));
        }

        this.pagination.page = 1;

        const model = {
            senderName: this.filterModel.senderName,
            requestId: this.filterModel.requestId,
            displayId: this.filterModel.displayId,
            clientName: this.filterModel.clientName,
            providerName: this.filterModel.providerName,
            createdDate: this.filterModel.createdDate,
            createdDateFrom: this.filterModel.createdDateFrom,
            createdDateTo: this.filterModel.createdDateTo,
            requestStatuses: this.filterModel.status,
            senderStatus: this.senderStatus !== '' ? parseInt(this.senderStatus, 10) : 0,
            sortDirection: this.pagination.descending,
            requestsFilterExpiryOption: this.requestsFilterExpiryOption,
            sortBy: this.pagination.sortBy,
            pageIndex: 0,
            pagesize: this.pagination.rowsPerPage,
        };

        const response = await this.dashboardService.Get(model);

        if (!response.isSuccess) {
            Toaster.error(response.errorMessage);
        }

        this.senders = response.result;
        this.sendersCount = response.totalCount;
        this.isFromFilterBox = false;
    }






    public selectAll() {
        if (this.selected.length) {
            this.selected = [];
            this.selectedIds = [];
            this.selectedSenderIds = [];
        } else {
            this.selected = this.senders.slice();
            this.selectedIds = this.senders.map((x) => x.id);
            this.selectedSenderIds = this.senders.map((x) => x.senderId);
        }
    }
    public select(event: any, id: string) {
        if (!event) {
            const index = this.selectedIds.indexOf(id);
            this.selectedIds.splice(index, 1);
            this.selectedSenderIds.splice(index, 1);
        } else {
            this.selectedIds.push(id);
            let selectedObj = this.selected.find(s => s.id == id);
            if (selectedObj !== undefined) {
                this.selectedSenderIds.push(selectedObj.senderId);
            }
        }
    }
    public getRate(remainingDays: string, totalDays: string) {
        return (parseInt(remainingDays, 10) / parseInt(totalDays, 10)) * 100;
    }
    public showapproveDialog(id: string) {
        if (id !== '') {
            this.selectedIds.push(id);
        }
        this.approveDialog = true;
    }
    public showFinalapproveDialog(id: string) {
        if (id !== '') {
            this.selectedIds.push(id);
        }
        this.finalApproveDialog = true;
    }
    public hideapproveDialog() {
        this.approveComment = '';
        this.approveDialog = false;
    }
    public hideFinalApproveDialog() {
        this.finalApproveDialog = false;
    }
    public async approve(id: string) {
        let ids: string[] = [];
        if (id !== '') {
            ids.push(id);
        } else {
            ids = this.selectedIds;
            if (this.senders.filter((s) => ids.includes(s.id) &&
                (s.requestStatus.toString() != '1' && s.requestStatus.toString() != '3')
            ).length > 0
            ) {
                Toaster.error(this.$t('dashboardPage.NotAllSenderPendingApproval').toString());
                return;
            }
            if (this.senders.filter((s) => ids.includes(s.id) && s.tenantId !== this.tenantId)
                .length > 0 && this.userRole === 1) {
                Toaster.error(this.$t('dashboardPage.NotAllSenderRequestRelatedToThisTenant').toString());
                return;
            }
        }
        const response = await this.dashboardService.approve(ids, this.approveComment);
        if (!response.isSuccess) {
            Toaster.error(response.errorMessage);
            await this.reload();
            this.ids = [];
            this.selectedIds = [];
            this.selectedSenderIds = [];
        } else {
            Toaster.success(this.$t('dashboardPage.Approvedsuccessfully').toString());
            await this.reload();
            this.ids = [];
            this.selectedIds = [];
            this.selectedSenderIds = [];
        }
        this.hideapproveDialog();
    }
    public async finalApprove(id: string) {
        let ids: string[] = [];
        if (id !== '') {
            ids.push(id);
        } else {
            ids = this.selectedIds;
            if (this.senders.filter((s) => ids.includes(s.id) &&
                (s.requestStatus.toString() == '4' || s.requestStatus.toString() == '5'
                    || s.requestStatus.toString() == '6' || s.requestStatus.toString() == '11' || (s.requestStatus.toString() == '3' && this.userRole !== 1 && this.userRole !== 9))
            ).length > 0
            ) {
                Toaster.error(this.$t('dashboardPage.NotAllSenderPendingApproval').toString());
                return;
            }
            if (this.senders.filter((s) => ids.includes(s.id) && s.tenantId !== this.tenantId)
                .length > 0 && this.userRole === 1) {
                Toaster.error(this.$t('dashboardPage.NotAllSenderRequestRelatedToThisTenant').toString());
                return;
            }
        }
        const response = await this.dashboardService.finalApprove(ids, this.approveComment);
        if (!response.isSuccess) {
            Toaster.error(response.errorMessage);
            this.hideFinalApproveDialog();
            await this.reload();
            this.ids = [];
            this.selectedIds = [];
        } else {
            Toaster.success(this.$t('shared.finalApprovedsuccessfully').toString());
            this.hideFinalApproveDialog();
            await this.reload();
            this.dashboardService.sendrApproveEmail(ids);
            this.ids = [];
            this.selectedIds = [];
        }
        this.hideFinalApproveDialog();
    }
    public showDeactivateDialog(id: string) {
        this.Deactivateids = [];
        this.deactivateIsBulkAction = id === '';
        if (id !== '') {
            this.Deactivateids.push(id);
        } else {
            this.Deactivateids = this.selectedIds;
        }
        this.deactivateDialog = true;
    }

    public get deactivateConfirmMessage(): string {
        return this.deactivateIsBulkAction
            ? this.$t('shared.deactivateInputText').toString()
            : this.$t('shared.deactivateInputTextSingle').toString();
    }

    public hideDeactivateDialog() {
        this.deleteComment = '';
        this.deactivateDialog = false;
    }
    public showDeleteDialog(id: string) {
        this.Deleteids = [];
        if (id !== '') {
            this.Deleteids.push(id);
        } else {
            this.Deleteids = this.selectedIds;
        }
        this.deleteDialog = true;
    }
    public hideDeleteDialog() {
        this.deleteDialog = false;
    }
    public isNumberFieldPaste(ev: any) {
        const paste = (ev.clipboardData).getData('text');
        if (isNaN(paste)) {
            ev.preventDefault();
        }
    }
    public isNumberField(val: KeyboardEvent) {
        if (!this.validationService.isNumber(val.key)) {
            val.preventDefault();
        }
    }
    public showresendDialog(id: string) {
        if (id !== '') {
            this.selectedIds.push(id);
        } else {
            this.resendids = this.selectedIds;
        }
        this.resendDialog = true;
    }
    public showFavoriteDialog(crNumber: string, unifiedNumber: string, customerType: number) {
        this.crNumber = crNumber;
        this.enterpriseUnifiedNumber = unifiedNumber;
        this.customerType = customerType;
        this.favoriteDialog = true;
    }

    public hideFavoriteDialog() {
        this.favoriteDialog = false;
    }
    public showUnfavoriteDialog(crNumber: string, unifiedNumber: string, customerType: any) {
        this.crNumber = crNumber;
        this.enterpriseUnifiedNumber = unifiedNumber;
        this.customerType = customerType;
        this.unfavoriteDialog = true;
    }
    public hideUnfavoriteDialog() {
        this.unfavoriteDialog = false;
    }
    public hideresendDialog() {
        this.resendComment = '';
        this.resendDialog = false;
    }
    public async exportToExcel() {
        this.loaderService.ShowLoader();
        this.reportModel.requestStatus = this.filterModel.status;
        this.reportModel.senderStatus = this.senderStatus !== '' ? parseInt(this.senderStatus, 0) : 0;
        this.reportModel.requestId = this.filterModel.requestId;
        this.reportModel.displayId = this.filterModel.displayId;
        this.reportModel.senderName = this.filterModel.senderName;
        this.reportModel.clientName = this.filterModel.clientName;
        this.reportModel.createdDateFrom = this.filterModel.createdDateFrom;
        this.reportModel.createdDateTo = this.filterModel.createdDateTo;
        this.reportModel.requestsFilterExpiryOption = this.requestsFilterExpiryOption;
        const response = await this.reportService.GetSenderNameAndBeneficiariesReport
            (this.reportModel, '0', '0', true);
        if (!response.isSuccess) {
            this.loaderService.HideLoader();
            Toaster.error(response.errorMessage);
        } else {
            this.loaderService.HideLoader();
        }
    }
    public async deactivate(id: string) {
        let ids: string[] = [];
        ids = this.Deactivateids;
        if (this.senders.filter((s) => ids.includes(s.id) && s.requestStatus.toString() !== '4' && s.requestStatus.toString() !== '5').length > 0) {
            Toaster.error(this.$t('dashboardPage.NotAllSenderActivateOrPartiallyActivated').toString());

            return;
        }
        const response = await this.dashboardService.deactivate(ids);
        if (!response.isSuccess) {
            Toaster.error(response.errorMessage);
            this.deactivateDialog = false;
            await this.reload();
        } else {
            this.deactivateDialog = false;
            this.selectedIds = [];
            this.selectedSenderIds = [];
            Toaster.success(this.$t('dashboardPage.deactivatedsuccessfully').toString());
            await this.reload();
        }
    }
    public async deleteSender() {
        let ids: string[] = [];
        ids = this.Deleteids;
        if (this.senders.filter((s) => ids.includes(s.id) && !(s.requestStatus.toString() === '4'
            || s.requestStatus.toString() === '2')).length > 0) {
            Toaster.error(this.$t('dashboardPage.NotAllSenderApprovedOrPaid').toString());
            return;
        }
        const response = await this.dashboardService.delete(ids[0], this.deleteComment);
        if (!response.isSuccess) {
            Toaster.error(response.errorMessage);
            this.deleteDialog = false;
            await this.reload();
        } else {
            this.deleteDialog = false;
            this.selectedIds = [];
            this.selectedSenderIds = [];
            this.dashboardService.deleteRequestEmail(this.Deleteids);
            Toaster.success(this.$t('shared.deleteSuccessfully').toString());
            await this.reload();
        }
    }
    public async favorClient() {
        const response = await this.dashboardService.FavorClient(
            this.crNumber,
            this.enterpriseUnifiedNumber,
            this.customerType,
        );

        if (!response.isSuccess) {
            Toaster.error(response.errorMessage);
        } else {
            Toaster.success(this.$t('shared.clientFavoriteSuccessfully').toString());
            await this.reload();
        }
        this.hideFavoriteDialog();
    }

    public async unfavorClient() {
        const response = await this.dashboardService.UnfavorClient(
            this.crNumber,
            this.enterpriseUnifiedNumber,
            this.customerType
        );

        if (!response.isSuccess) {
            Toaster.error(response.errorMessage);
        } else {
            Toaster.success(this.$t('shared.clientUnfavoriteSuccessfully').toString());
            await this.reload();
        }
        this.hideUnfavoriteDialog();
    }

    public async resend(id: string) {
        let ids: string[] = [];
        if (id !== '') {
            ids.push(id);
        } else {
            ids = this.selectedIds;
            if (this.senders.filter((s) => ids.includes(s.id) && s.requestStatus.toString() !== '3')
                .length > 0) {
                Toaster.error(this.$t('dashboardPage.NotAllSenderRejected').toString());
                return;
            }
        }
        const response = await this.dashboardService.resend(ids, this.resendComment);
        if (!response.isSuccess) {
            Toaster.error(response.errorMessage);
        } else {
            await this.dashboardService.resendRequestEmail(ids);
            this.selectedIds = [];
            this.selectedSenderIds = [];
            Toaster.success(this.$t('dashboardPage.resentSuccessfully').toString());
            await this.reload();
        }
        this.hideresendDialog();
    }
    public async showRejectDialog(item?: SenderRequestModel) {

        this.ids = [];
        if (item) {
            this.ids.push(item.id);
            if ([2, 5].includes(this.userRole)) {

                if (item.providerRejected) {
                    Toaster.error(this.$t('dashboardPage.providerAlreadyRejected').toString());
                    return;
                }
                if (!this.isWithinTwoHours(item.createdDateTime)) {
                    Toaster.error(this.$t('dashboardPage.providerRejectTimeExpired').toString());
                    return;
                }
                if (!this.popUpRejectionReasons) {
                    this.popUpRejectionReasons = [];
                }
                if ([2, 5].includes(this.userRole)) {
                    const providerReason = { id: "0", rejectionText: 'Rejected by provider', requestType: 1 } as RejectionReasonModel;

                    if (!this.popUpRejectionReasons.some(x => x.rejectionText === providerReason.rejectionText)) {
                        this.popUpRejectionReasons.unshift(providerReason);
                    }

                    this.selectedRejectReason = providerReason;
                    this.rejectResone = providerReason.rejectionText;

                } else {
                    this.popUpRejectionReasons = this.popUpRejectionReasons.filter(
                        x => x.rejectionText !== 'Rejected by provider'
                    );

                    if (this.selectedRejectReason && this.selectedRejectReason.rejectionText === 'Rejected by provider') {
                        this.selectedRejectReason = { id: '', rejectionText: '', requestType: 0 } as RejectionReasonModel;
                        this.rejectResone = '';
                    }
                }




                }
            } else {
                this.ids = this.selectedIds;
            }
            if (this.senders.filter((s) => this.ids.includes(s.id) &&
                (s.requestStatus.toString() == '4' || s.requestStatus.toString() == '5'
                    || s.requestStatus.toString() == '6' || s.requestStatus.toString() == '11' || (s.requestStatus.toString() == '2' && this.userRole !== 1 && this.userRole !== 9))
            ).length > 0) {
                Toaster.error(this.$t('dashboardPage.NotAllSenderPendingApproval').toString());
                return;
            }

            this.rejectdialog = true;
        }
    
    public async hideRejectDialog() {
        this.rejectResone = '';
        this.rejectdialog = false;
    }
    public async reject() {
        if (this.senders.filter((s) => this.ids.includes(s.id) && s.tenantId !== this.tenantId)
            .length > 0 && this.userRole === 1) {
            Toaster.error(this.$t('dashboardPage.NotAllSenderRequestRelatedToThisTenant').toString());
            return;
        }
        if (this.rejectResone !== '') {
            this.rejectdialog = false;
            const response = await this.dashboardService.reject(this.ids, this.rejectResone);
            if (!response.isSuccess) {
                Toaster.error(response.errorMessage);
            } else {
                if (![2, 5].includes(this.userRole))
                    await this.dashboardService.rejectRequestEmail(this.ids);
                this.rejectResone = '';
                this.selectedIds = [];
                this.selectedSenderIds = [];
                this.ids = [];
                Toaster.success(this.$t('dashboardPage.Rejectedsuccessfully').toString());
                await this.reload();
            }
        }
    }
    public PreparePay(id: string) {
        let ids: string[] = [];
        if (id !== '') {
            ids.push(id);
        } else {
            ids = this.selectedIds;
            if (this.senders.filter((s) => ids.includes(s.id) && s.requestStatus.toString() !== '2')
                .length > 0) {
                Toaster.error(this.$t('dashboardPage.NotAllSenderPendingPay').toString());
                return;
            }
        }
        const storSettings = {
            pagination: this.pagination,
            filter: {
                senderName: this.filterModel.senderName,
                requestId: this.filterModel.requestId,
                clientName: this.filterModel.clientName,
                providerName: this.filterModel.providerName,
                createdDate: this.filterModel.createdDate,
                // requestStatus: this.requestStatusBox !== '' ? parseInt(this.requestStatusBox, 0) : 0,
                createdDateFrom: this.filterModel.createdDateFrom,
                createdDateTo: this.filterModel.createdDateTo,
                requestStatuses: this.filterModel.status,
                senderStatus: this.senderStatus !== '' ? parseInt(this.senderStatus, 0) : 0,
                pageIndex: (this.pagination.page - 1).toString(),
                pagesize: this.pagination.rowsPerPage,
                sortDirection: this.pagination.descending,
                sortBy: this.pagination.sortBy,
            },
        };
        localStorage.storSettings = JSON.stringify(storSettings);
        this.$router.push({ name: 'Payment', params: { ids: ids.join(',') } });
    }
    public Details(id: string) {
        const storSettings = {
            pagination: this.pagination,
            filter: {
                senderName: this.filterModel.senderName,
                requestId: this.filterModel.requestId,
                displayId: this.filterModel.displayId,
                clientName: this.filterModel.clientName,
                providerName: this.filterModel.providerName,
                createdDate: this.filterModel.createdDate,
                // requestStatus: this.requestStatusBox !== '' ? parseInt(this.requestStatusBox, 0) : 0,
                senderStatus: this.senderStatus !== '' ? parseInt(this.senderStatus, 0) : 0,
                createdDateFrom: this.filterModel.createdDateFrom,
                createdDateTo: this.filterModel.createdDateTo,
                requestStatuses: this.filterModel.status,
                requestsFilterExpiryOption: this.requestsFilterExpiryOption,
                pageIndex: (this.pagination.page - 1).toString(),
                pagesize: this.pagination.rowsPerPage,
                sortDirection: this.pagination.descending,
                sortBy: this.pagination.sortBy,
            },
        };
        localStorage.storSettings = JSON.stringify(storSettings);
        this.$router.push({ name: 'SenderInfo', params: { id } });
    }
    public async checkRenewSender(senderId: string) {
        if (this.isAnySelected) {
            let ids: string[] = [];
            if (senderId !== '') {
                ids.push(senderId);
            } else {
                ids = this.selectedSenderIds;
            }
            const response = await this.dashboardService.checkRenewSender(ids);
            if (!response.isSuccess) {
                Toaster.error(response.errorMessage);
                await this.reload();
                this.selectedIds = [];
                this.selectedSenderIds = [];
            } else {
                const joined = ids.join(',');
                this.$router.push({
                    name: 'RenewRegisterSender',
                    params: { ids: joined },
                    query: { renewalSource: 'senderDashboard', ids: joined },
                });
            }
        } else {
            this.$router.push({
                name: 'RenewRegisterSender',
                query: { renewalSource: 'senderDashboard' },
            });
        }
    }

    public ChangeSenderType(id: string) {
        const storSettings = {
            pagination: this.pagination,
            filter: {
                senderName: this.filterModel.senderName,
                requestId: this.filterModel.requestId,
                displayId: this.filterModel.displayId,
                clientName: this.filterModel.clientName,
                providerName: this.filterModel.providerName,
                createdDate: this.filterModel.createdDate,
                createdDateFrom: this.filterModel.createdDateFrom,
                createdDateTo: this.filterModel.createdDateTo,
                requestStatuses: this.filterModel.status,
                // requestStatus: this.requestStatusBox !== '' ? parseInt(this.requestStatusBox, 0) : 0,
                senderStatus: this.senderStatus !== '' ? parseInt(this.senderStatus, 0) : 0,
                pageIndex: (this.pagination.page - 1).toString(),
                pagesize: this.pagination.rowsPerPage,
                sortDirection: this.pagination.descending,
                sortBy: this.pagination.sortBy,
            },
        };
        localStorage.storSettings = JSON.stringify(storSettings);
        this.$router.push({ name: 'ChangeSenderType', params: { id } });
    }
    public ConectivityDetail(senderId: string) {
        this.$router.push({ name: 'SenderConectivityDetail', params: { senderId } });
    }
    public async updatePaginate(val: any) {
        const model = {
            senderName: this.filterModel.senderName,
            requestId: this.filterModel.requestId,
            displayId: this.filterModel.displayId,
            clientName: this.filterModel.clientName,
            providerName: this.filterModel.providerName,
            createdDate: this.filterModel.createdDate,
            createdDateFrom: this.filterModel.createdDateFrom,
            createdDateTo: this.filterModel.createdDateTo,
            requestStatuses: this.filterModel.status,
            senderStatus: this.senderStatus !== '' ? parseInt(this.senderStatus, 0) : 0,
            requestsFilterExpiryOption: this.requestsFilterExpiryOption,
            pageIndex: (val.page - 1).toString(),
            pagesize: val.rowsPerPage,
            sortDirection: this.pagination.descending,
            sortBy: this.isSorted ? this.pagination.sortBy : '',
        };
        const response = await this.dashboardService.Get(model);
        if (!response.isSuccess) {
            Toaster.error(response.errorMessage);
        }
        this.senders = response.result;
        this.sendersCount = response.totalCount;
        this.pagination.page = val.page;
        this.pagination.rowsPerPage = val.rowsPerPage;
    }
    public get isAnySelected(): boolean {
        this.anySelected = this.selectedIds.length > 0;
        return this.anySelected;
    }
    public async reload() {
        this.isSorted = false;
        this.requestsFilterExpiryOption = 0;
        const model = {
            senderName: this.filterModel.senderName,
            requestId: this.filterModel.requestId,
            displayId: this.filterModel.displayId,
            clientName: this.filterModel.clientName,
            providerName: this.filterModel.providerName,
            createdDate: this.filterModel.createdDate,
            createdDateFrom: this.filterModel.createdDateFrom,
            createdDateTo: this.filterModel.createdDateTo,
            requestStatuses: this.filterModel.status,
            senderStatus: this.senderStatus !== '' ? parseInt(this.senderStatus, 0) : 0,
            requestsFilterExpiryOption: 0,
            pageIndex: '0',
            pagesize: '10',
            sortDirection: true,
            sortBy: 'createdDate',
        };
        const response = await this.dashboardService.Get(model);
        this.dashboardBoxes = await this.dashboardService.GetDashboardBoxes();
        if (!response.isSuccess) {
            Toaster.error(response.errorMessage);
        }
        this.senders = response.result;
        this.sendersCount = response.totalCount;
        this.selectedIds = [];
        this.selectedSenderIds = [];
        this.selected = [];
        if (this.pagination != undefined) {
            this.pagination.rowsPerPage = 10;
            this.pagination.page = 1;
        }
    }

    @Watch('requestsFilterExpiryOption', { deep: true })
    public onchangeRequestsFilterExpiry() {
        this.search();
    }

    public get rejectReasonIsValid(): boolean {
        return this.rejectResone !== '';
    }
    public async getRejectionReasons() {
        const response = await this.dashboardService.getSenderNameRejectReasons(1);
        this.popUpRejectionReasons = response.result;
        this.popUpRejectionReasons.push({ id: '0', rejectionText: 'other', requestType: 1 })

    }
    public handleItemChange() {
        if (this.selectedRejectReason.id == '0') {
            this.isItOtherReasonPorp = true;
            this.rejectResone = '';
        }
        else {
            this.isItOtherReasonPorp = false;
            this.rejectResone = this.selectedRejectReason.rejectionText
        }
    }
    public get isItOtherReason(): boolean {
        return this.isItOtherReasonPorp;
    }

    private searchTimeout: any = null;

    public onInputSearch() {
        if (this.searchTimeout) clearTimeout(this.searchTimeout);
        this.searchTimeout = setTimeout(() => {
            this.search();
        }, 1000);
    }

    public onDateChange(field: 'from' | 'to') {
        if (field === 'from') this.createdDateFromMenu = false;
        if (field === 'to') this.createdDateToMenu = false;

        this.search();
    }

}
